var _path, _g, _path2, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2916 20.1667H5.6902C4.95637 20.1661 4.24583 19.909 3.6816 19.4398L2.87942 18.7725C2.4713 18.434 2.15606 17.9973 1.96342 17.5033C1.77078 17.0094 1.70708 16.4745 1.77832 15.9491L2.31027 11.9606C2.37127 11.4992 2.53448 11.0573 2.78801 10.667C3.04153 10.2767 3.37897 9.94794 3.77571 9.70465L5.78252 8.46731C5.4163 7.63221 5.20696 6.73683 5.16497 5.82593C5.16497 3.54037 9.03563 0 10.9909 0C12.9462 0 16.8168 3.54037 16.8168 5.82593C16.7749 6.73679 16.5658 7.63217 16.1997 8.46731L18.2971 9.75977C18.6632 9.98629 18.9789 10.2855 19.2247 10.639C19.4705 10.9924 19.6412 11.3925 19.7262 11.8145L20.2254 15.9747C20.2887 16.494 20.2205 17.0209 20.0271 17.507C19.8337 17.9931 19.5212 18.4229 19.1185 18.7568L18.3002 19.4393C17.7361 19.9089 17.0255 20.1662 16.2916 20.1667Z",
    fill: "url(#paint0_linear_1595_2920)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1595_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9914 10.7552C9.38303 10.7552 7.40625 8.28453 7.40625 6.27368C7.4061 6.19487 7.42673 6.1174 7.46607 6.04911C7.50541 5.98081 7.56207 5.9241 7.63032 5.88469L9.87824 4.60075C10.2169 4.40799 10.5999 4.30664 10.9896 4.30664C11.3793 4.30664 11.7624 4.40799 12.1011 4.60075L14.3525 5.88559C14.4207 5.92492 14.4772 5.98149 14.5166 6.04962C14.5559 6.11774 14.5766 6.19502 14.5766 6.27368C14.5766 8.28453 12.5998 10.7552 10.9914 10.7552Z",
    fill: "#1D1D1D",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9914 10.7552C9.38303 10.7552 7.40625 8.28453 7.40625 6.27368C7.4061 6.19487 7.42673 6.1174 7.46607 6.04911C7.50541 5.98081 7.56207 5.9241 7.63032 5.88469L9.87824 4.60075C10.2169 4.40799 10.5999 4.30664 10.9896 4.30664C11.3793 4.30664 11.7624 4.40799 12.1011 4.60075L14.3525 5.88559C14.4207 5.92492 14.4772 5.98149 14.5166 6.04962C14.5559 6.11774 14.5766 6.19502 14.5766 6.27368C14.5766 8.28453 12.5998 10.7552 10.9914 10.7552Z",
    fill: "url(#paint1_linear_1595_2920)",
    fillOpacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9893 4.80664C11.2166 4.80664 11.4413 4.85109 11.6504 4.93652L11.8535 5.03516L14.0752 6.30273C14.0656 7.1549 13.6381 8.15471 12.9971 8.95605C12.3341 9.78479 11.5656 10.2549 10.9912 10.2549C10.4168 10.2548 9.64925 9.78464 8.98633 8.95605C8.34495 8.15437 7.91551 7.15421 7.90625 6.30176L10.126 5.03516C10.3891 4.8855 10.6866 4.80671 10.9893 4.80664Z",
    stroke: "url(#paint2_linear_1595_2920)",
    strokeOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1595_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94284 10.5692C6.01214 10.6658 6.11695 10.7308 6.23424 10.7501C6.35152 10.7694 6.47166 10.7413 6.56823 10.672C6.66481 10.6027 6.72989 10.4979 6.74918 10.3806C6.76847 10.2634 6.74038 10.1432 6.67108 10.0466C6.31797 9.55376 6.0201 9.02356 5.78285 8.46558L5.77748 8.46289V8.46737L5.01562 8.93838C5.26744 9.5126 5.57818 10.0591 5.94284 10.5692Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1595_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0467 10.5692C15.9774 10.6658 15.8725 10.7308 15.7553 10.7501C15.638 10.7694 15.5178 10.7413 15.4213 10.672C15.3247 10.6027 15.2596 10.4979 15.2403 10.3806C15.221 10.2634 15.2491 10.1432 15.3184 10.0466C15.6718 9.55388 15.9699 9.02365 16.2071 8.46558L16.212 8.46289V8.46737L16.9739 8.93838C16.7222 9.51268 16.4115 10.0592 16.0467 10.5692Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -7.21875,
    y: 1.39062,
    width: 36.4336,
    height: 32.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_1595_2920_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1595_2920)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0759 13.5303C16.9862 13.4408 16.8645 13.3905 16.7378 13.3906H5.25951C5.13267 13.3906 5.01102 13.441 4.92133 13.5307C4.83164 13.6204 4.78125 13.742 4.78125 13.8689V21.5211C4.78125 21.6479 4.83164 21.7695 4.92133 21.8592C5.01102 21.9489 5.13267 21.9993 5.25951 21.9993H16.7378C16.8646 21.9993 16.9863 21.9489 17.076 21.8592C17.1656 21.7695 17.216 21.6479 17.216 21.5211V13.8689C17.2161 13.806 17.2037 13.7437 17.1797 13.6856C17.1556 13.6275 17.1204 13.5747 17.0759 13.5303Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0759 13.5303C16.9862 13.4408 16.8645 13.3905 16.7378 13.3906H5.25951C5.13267 13.3906 5.01102 13.441 4.92133 13.5307C4.83164 13.6204 4.78125 13.742 4.78125 13.8689V21.5211C4.78125 21.6479 4.83164 21.7695 4.92133 21.8592C5.01102 21.9489 5.13267 21.9993 5.25951 21.9993H16.7378C16.8646 21.9993 16.9863 21.9489 17.076 21.8592C17.1656 21.7695 17.216 21.6479 17.216 21.5211V13.8689C17.2161 13.806 17.2037 13.7437 17.1797 13.6856C17.1556 13.6275 17.1204 13.5747 17.0759 13.5303Z",
    fill: "url(#paint3_linear_1595_2920)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7158 13.8906V21.499H5.28125V13.8906H16.7158Z",
    stroke: "url(#paint4_linear_1595_2920)",
    strokeOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1595_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9973 19.1313C11.7897 19.1313 12.4321 18.4889 12.4321 17.6965C12.4321 16.9041 11.7897 16.2617 10.9973 16.2617C10.2049 16.2617 9.5625 16.9041 9.5625 17.6965C9.5625 18.4889 10.2049 19.1313 10.9973 19.1313Z",
    fill: "white",
    fillOpacity: 0.23
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1595_2920",
    x: 7.40625,
    y: 4.30664,
    width: 7.17188,
    height: 8.44873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1595_2920",
    x: 5.01562,
    y: 8.46289,
    width: 1.73828,
    height: 4.29297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1595_2920",
    x: 15.2344,
    y: 8.46289,
    width: 1.73828,
    height: 4.29297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2920"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1595_2920",
    x: -7.21875,
    y: 1.39062,
    width: 36.4336,
    height: 32.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2920"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1595_2920_clip_path",
    transform: "translate(7.21875 -1.39062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0759 13.5303C16.9862 13.4408 16.8645 13.3905 16.7378 13.3906H5.25951C5.13267 13.3906 5.01102 13.441 4.92133 13.5307C4.83164 13.6204 4.78125 13.742 4.78125 13.8689V21.5211C4.78125 21.6479 4.83164 21.7695 4.92133 21.8592C5.01102 21.9489 5.13267 21.9993 5.25951 21.9993H16.7378C16.8646 21.9993 16.9863 21.9489 17.076 21.8592C17.1656 21.7695 17.216 21.6479 17.216 21.5211V13.8689C17.2161 13.806 17.2037 13.7437 17.1797 13.6856C17.1556 13.6275 17.1204 13.5747 17.0759 13.5303Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1595_2920",
    x: 9.5625,
    y: 16.2617,
    width: 2.87109,
    height: 4.86963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1595_2920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1595_2920",
    x1: 5.30937,
    y1: -1.7069,
    x2: 26.251,
    y2: 10.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B794FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664482,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1595_2920",
    x1: 7.40625,
    y1: 4.30664,
    x2: 15.7335,
    y2: 6.65777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1595_2920",
    x1: 7.63032,
    y1: 4.59976,
    x2: 14.5766,
    y2: 4.59976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1595_2920",
    x1: 4.78125,
    y1: 13.3906,
    x2: 18.5247,
    y2: 18.4313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1595_2920",
    x1: 5.16984,
    y1: 13.7819,
    x2: 17.216,
    y2: 13.7819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM02);
export default __webpack_public_path__ + "static/media/m_02.9d03e9d9064851aa1616a551acd61ccf.svg";
export { ForwardRef as ReactComponent };